import React from 'react'
import PropTypes from 'prop-types'

import { Body, DismissButton, Message, Title } from './Notifications.board.style'

function MessageComponent({ body, callback, dismissed, id, isDismissible, onClickDismiss, theme, title }) {
    return (
        <Message withLink={!!callback} dismissed={dismissed} theme={theme}>
            <Title>
                {title}
                {isDismissible && <DismissButton onClick={() => onClickDismiss(id)}>&times;</DismissButton>}
            </Title>
            <Body withLink={!!callback} onClick={callback}>
                {body}
            </Body>
        </Message>
    )
}

MessageComponent.propTypes = {
    body: PropTypes.string,
    callback: PropTypes.func,
    dismissed: PropTypes.bool,
    id: PropTypes.string,
    isDismissible: PropTypes.bool,
    onClickDismiss: PropTypes.func,
    theme: PropTypes.string,
    title: PropTypes.string,
}

MessageComponent.defaultProps = {
    body: '',
    callback: null,
    dismissed: false,
    id: '',
    isDismissible: false,
    onClickDismiss: () => null,
    theme: null,
    title: '',
}

export default MessageComponent
